// extracted by mini-css-extract-plugin
export default {"readOnly":"readOnly__jWq5C2"};